module.exports = __webpack_public_path__ + "static/Pt09-1aaafda12b28e86d4b40b09fce47d259.jpg";